import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { useFormikContext, useField } from 'formik'

// Components
import Checkbox from '@/components/common/Checkbox'

// Variables / Functions
import styles from './style.module.scss'

const cx = classnames.bind(styles)

export const propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
}

export const defaultProps = {
  onChange: () => {},
}

function CheckboxField(props) {
  const { className, name, onChange: onChangeProps, ...restProps } = props
  const [field] = useField(props)
  const { setFieldValue } = useFormikContext()

  const onChange = (event) => {
    const value = event.target.checked

    setFieldValue(field.name, value)
    onChangeProps(value)
  }

  return (
    <div className={cx('checkbox-field-wrapper', className)}>
      <Checkbox className={cx('ckeckbox-field-wrapper-checkbox')} onChange={onChange} checked={field.value} name={name} {...restProps} />
    </div>
  )
}

CheckboxField.propTypes = propTypes
CheckboxField.defaultProps = defaultProps

export default CheckboxField
